<template>
  <DpplTooltip
    class="first-draft-language-tooltip"
    :hide-tooltip="!show"
    :light-mode="lightMode"
    tooltip-placement="bottom"
    teleport
  >
    <template #activator>
      <slot />
    </template>
    <template #tooltip-content>
      <p class="text-body-3">
        {{ text }}
      </p>
    </template>
  </DpplTooltip>
</template>

<script setup>
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';
import { FIRST_DRAFT_POST_TOOLTIP } from '@/helpers/language';

defineProps({
  show: { type: Boolean, default: false },
  text: { type: String, default: FIRST_DRAFT_POST_TOOLTIP },
  lightMode: { type: Boolean, default: true },
});
</script>

<style scoped lang="less">
.first-draft-language-tooltip {
  display: inline-flex;
  align-items: center;

  :deep(.activator) {
    display: inline-flex;
    align-items: center;
  }
}
</style>
